<template>
  <div id="footer">
    <div class="width_wrap">
      <!-- 상단 바로가기 -->
      <a
        @click="scrollToTop"
        id="gotop"
        :class="{ on: isScrolled }"
        style="cursor: pointer"
        >TOP</a
      >
      <!-- // 상단 바로가기 -->
      <!-- ***템플릿 호환가능*** -->

      <div class="footer_01">
        <div class="footer_info">
          <dl>
            <dt>
              <h1>주식회사 코코랩 COKOLab. Inc.</h1>

              <div class="navi_foot">
                <ul>
                  <li>
                    <router-link :to="`${USER_ROUTES.About.Path}`"
                      >연구소소개</router-link
                    >
                  </li>
                  <li>
                    <router-link :to="`${USER_ROUTES.Privacy.Path}`"
                      >개인정보처리방침</router-link
                    >
                  </li>
                  <li>
                    <router-link :to="`${USER_ROUTES.Notice.Path}`"
                      >커뮤니티</router-link
                    >
                  </li>
                </ul>
              </div>
              <div class="address">
                <ul>
                  <li>COKOLab. Inc.</li>
                  <li>
                    주소 : 대전 유성구 엑스포로123번길 27-22 (도룡동) KCC
                    웰츠타워 101동 1107호
                  </li>
                </ul>
                <ul>
                  <li>사업자등록번호 : 214-87-42385</li>
                  <li>통신판매업신고번호 : 2025-대전유성-0742</li>
                </ul>
                <ul>
                  <li>TEL. 042-867-5558</li>
                  <li>FAX. 042-867-7228</li>
                  <li>EMAIL : admin@cokolab.com</li>
                </ul>
                <ul>
                  <li>Copyright(c) COKOLab. Inc.. All Rights Reserved.</li>
                </ul>
              </div>
            </dt>
            <dd>
              <h2>오시는 길</h2>
              <router-link :to="`${USER_ROUTES.About.Map.Path}`"
                >지도보기
              </router-link>
            </dd>
          </dl>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from "vue";
import { USER_ROUTES } from "@/assets/route_constants.ts";

const isScrolled = ref(false);

// 스크롤 이벤트 핸들러
const handleScroll = () => {
  isScrolled.value = window.scrollY > 0;
};

// 최상단으로 스크롤
const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

// 라이프사이클 훅
onMounted(() => {
  window.addEventListener("scroll", handleScroll);
});

onBeforeUnmount(() => {
  window.removeEventListener("scroll", handleScroll);
});
</script>

<style scoped>
.footer_01 * {
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  box-sizing: border-box;
}
.footer_01 {
  padding: 40px 10px;
  text-align: center;
}
.footer_01 > div > dl {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.footer_01 > div > dl dt {
  width: 100%;
}
.footer_01 > div > dl dd {
  width: 100%;
  background: #be7b42;
  padding: 40px 20px;
  border-radius: 15px;
}
.footer_01 > div > dl dd h2 {
  font-size: 19px;
  color: #fff;
  text-align: center;
  font-weight: 600;
}
.footer_01 > div > dl dd a {
  border: 1px solid #ddd;
  width: 150px;
  display: block;
  color: #fff;
  margin: 20px auto 0 auto;
  text-align: center;
  border-radius: 5px;
  padding: 9px 0;
}
.footer_01 > div > dl dt h1 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 20px;
}
.footer_01 > div > dl dt span {
  display: block;
  font-size: 13px;
  font-weight: 400;
  padding-top: 3px;
}
.footer_01 > div > dl dt ul li {
  display: inline-block;
  padding: 0 6px 0 0;
  font-size: 14px;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  font-weight: 500;
  line-height: 1.7em;
  color: #333;
}
.footer_01 > div > dl dt ul li a {
  color: #666;
}
.footer_01 > div > dl dt {
  margin-bottom: 10px;
}
.footer_01 > div > dl dt img {
  height: 40px;
}
.footer_01 > div > dl dt ul li a.btn1 {
  border: 1px solid #ccc;
  font-size: 11px;
  padding: 2px 7px;
}
@media screen and (min-width: 768px) {
  .footer_01 {
    padding: 40px 0px;
    text-align: left;
  }
  .address ul {
    text-align: left;
  }
  .footer_01 > div > dl dt {
    width: 70%;
  }
  .footer_01 > div > dl dd {
    width: 30%;
    padding: 50px 20px;
  }
}
@media screen and (min-width: 1100px) {
  .footer_info {
    max-width: 1200px;
    margin: 0 auto;
  }
  .footer_01 > div > dl dt {
    width: 65%;
  }
  .footer_01 > div > dl dd {
    width: 26%;
    padding: 40px 20px;
  }
}

.navi_foot {
  margin-bottom: 10px;
}
.navi_foot li {
  display: inline-block;
  position: relative;
  padding: 0 !important;
}
.navi_foot li a {
  padding: 0 10px;
  display: inline-block;
}
.navi_foot li:first-child a {
  padding: 0 10px 0 0;
}
.navi_foot li:after {
  content: "";
  position: absolute;
  left: 0;
  top: 3px;
  width: 1px;
  height: 10px;
  background: #ccc;
}
.navi_foot li:first-child:after {
  display: none;
}
.navi_foot li a {
  display: block;
  font-size: 14px;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  font-weight: 500;
  box-sizing: border-box;
  color: #333;
}
.navi_foot li a:hover {
  text-decoration: underline;
}
</style>
